import { Outlet, useNavigate } from "react-router-dom";
import { Box } from "@/ui";
import { LeftNavBar as LeftNavBarNusre } from "@/components/nurse/AppShell";
import { LeftNavBar as LeftNavBarTaxi } from "@/components/taxi/AppShell";
import { useSystemContext } from "@/provider/common/SystemProvider";
import { BurgerMenu } from "@/components/common/mobile/Menu";
import { CofidocContract, fetchCofidocContracts } from "@/api/billing/fetchCofidocContracts";
import { useState, useEffect } from "react";
import { AppProvider } from "@/provider/common/AppProvider";
import { CofidocHistory, fetchCofidocHistory } from "@/api/billing/fetchCofidocHistory";
import { CofidocBilling } from "@/api/billing/fetchCofidocBill";
import { orderBy } from "lodash";
import { fetchCofidocBillings } from "@/api/billing/fetchCofidocBillings";
import { addMonths } from "date-fns";
import { getSelectedPraticienFiness } from "@/utils/localStorage";
import { setAccessToken, setIdToken, setRefreshToken } from "@/utils/localStorage";

// Retourne le contrat actif de la catégorie, sinon le plus récemment expiré
// (plutôt que rien), pour permettre d'afficher un contrat expiré côté UI.
function findLatestContract(contracts: CofidocContract[], typeProduit: number) {
  const matches = contracts.filter((c) => c.typeProduit === typeProduit);
  const active = matches.find((c) => c.active);
  if (active) return active;

  return [...matches].sort((a, b) => {
    const dateA = new Date(a.terminationDate || a.subscriptionDate || 0).getTime();
    const dateB = new Date(b.terminationDate || b.subscriptionDate || 0).getTime();
    return dateB - dateA;
  })[0];
}

export default function App() {
  const { isMobile, setLoading, getUser, setUser } = useSystemContext();
  const [periodeStart, setPeriodeStart] = useState(new Date(new Date().setMonth(new Date().getMonth() - 1)));
  const [periodeEnd, setPeriodeEnd] = useState(new Date(new Date().setMonth(new Date().getMonth() + 1)));
  const [contract, setContract] = useState<CofidocContract>(null);
  const [optionGestion, setOptionGestion] = useState<CofidocContract>(null);
  const [optionECoficoffre, setOptionECoficoffre] = useState<CofidocContract>(null);
  const [lastHistory, setHistory] = useState<CofidocHistory>();
  const [relatedLastBill, setBilling] = useState<CofidocBilling>();

  const navigate = useNavigate();
  async function getMainData() {
    try {
      console.log("get main data");
      setLoading(true);
      const user = getUser();
      const email = user?.email || null;
      const username = user?.identifiant || null;
      const selectedFiness = getSelectedPraticienFiness();
      console.log("selectedFiness", selectedFiness);
      if(!selectedFiness) {
        navigate("/welcome");
        setIdToken("");
        setUser("");
        setAccessToken("");
        setRefreshToken("");
      }
      const [contracts, historyRes] = await Promise.all([
        fetchCofidocContracts({ username, email }),
        fetchCofidocHistory({ username, email }),
      ]);
      const findedContract = findLatestContract(contracts, 1);
      const findedGestion = findLatestContract(contracts, 2);
      const findedCoficoffre = contracts.find((c) => c.productName === "eCofiCoffre" && c.active);
      const h = orderBy(historyRes, "date", "desc")[0];
      setHistory(h);
      const billingRes = await fetchCofidocBillings({ username, email });
      const r = orderBy(billingRes, "date", "desc")[0];

      setBilling(r);

      setContract(findedContract);
      setOptionGestion(findedGestion);
      setOptionECoficoffre(findedCoficoffre);
    } catch (error) {
      console.log("error :", error);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    getMainData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <AppProvider
        value={{
          periodeStart,
          periodeEnd,
          setPeriodeStart,
          setPeriodeEnd,
          contract,
          lastHistory,
          relatedLastBill,
          optionGestion,
          optionECoficoffre,
        }}
      >
        {isMobile ? <RenderMobile /> : <RenderWeb />}
      </AppProvider>
    </>
  );
}
function RenderWeb() {
  const { getUser } = useSystemContext();

  let user = getUser();

  const isTaxi = user?.praticiens?.[0]?.code_specialite === "90";
  return (
    <Box flexDirection="column" height="100vh" justifyContent="center" alignItems="center" width="100vw">
      <div className="background-mountain-cofidoc" />
      <div className="background-cloud height40" />
      <div className="background-nav-bar" />
      <Box flexDirection="row" width="100%" height="100%" alignItems="center">
        {isTaxi ? <LeftNavBarTaxi /> : <LeftNavBarNusre />}

        <Box
          flexDirection="column"
          width="calc(100% - 170px)"
          height="100%"
          alignItems="flex-start"
          className="overBg"
          style={{ overflowY: "scroll", overflowX: "auto" }}
        >
          <Outlet />
        </Box>
      </Box>
    </Box>
  );
}

function RenderMobile() {
  return (
    <Box width="100vw" height="100vh" justifyContent="center" alignItems="center" flexDirection="column">
      <div className="background-mountain-cofidoc" />
      <div className="background-cloud height40" />
      <div className="background-over" />
      <BurgerMenu />
      <Box flexDirection="column" width="100%" height="100%" alignItems="center" className="overBg">
        <Outlet />
      </Box>
    </Box>
  );
}
